import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


@Injectable()
export class QuickviewService {

  constructor(private http: HttpClient) {
  }

  // Get from the API
  getNotes(): any {
    return this.http.get('assets/data/notes.json').pipe(
      map(res => res));
  }

  getUsers(): any {
    return this.http.get('assets/data/users.json').pipe(
      map(res => res));
  }

  getChatMessages(): any {
    return this.http.get('assets/data/messages.json').pipe(
      map(res => res));
  }
}
